import React, { useRef } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { QmsDataTable } from "../_common/QmsDataTable";
import cmtCategoryActions from "../../../_actions/_qmsActions/cmtCategoryActions";
import QmsAdminModal_EditCmtCategory from "./QmsAdminModal_EditCmtCategory";
import qmsFrameworkChangeActions from "../../../_actions/_qmsActions/qmsFrameworkChangeActions";
import QmsAdminModal_EditQmsFrameworkChange from "./QmsAdminModal_EditQmsFrameworkChange";

export default function QmsAdminCmtQmsFrameworkChanges(props) {
  const { divisionId } = props;

  const dispatch = useDispatch();
  useEffect(() => dispatch(qmsFrameworkChangeActions.getAll(divisionId)), [divisionId]);

  const qmsFrameworkChanges = useSelector(
    (state) => state.qms.qmsFrameworkChanges[divisionId] || null
  );

  const columns = useRef([
    {
      id: "label",
      numeric: false,
      disablePadding: true,
      label: "QMS Framework Change Type",
    },
    {
      id: "description",
      numeric: false,
      disablePadding: false,
      label: "Description",
    },
  ]);

  return (
    <QmsDataTable
      data={qmsFrameworkChanges || []}
      columns={columns.current}
      idName="qmsFrameworkChangeId"
      editModalComponent={
        <QmsAdminModal_EditQmsFrameworkChange divisionId={divisionId} />
      }
      onDelete={(ids) => dispatch(qmsFrameworkChangeActions.removeRange(ids, divisionId))}
      isExpandable={false}
    />
  );
}
